export default {"src":"/_next/static/media/wheel.08852450.svg","height":48,"width":48};